var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"e-dialog"},[_c('router-link',{staticClass:"e-dialog__back",attrs:{"to":{ name: 'chatDialogs' }}},[_c('IconChevronLeft')],1),_c('read-chat',{attrs:{"prop-id":_vm.propId,"prop-messages":_vm.propMessages,"opponent":_vm.opponent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }